/* Custom Event */
export const ITEM_ADDED_TO_CART = 'Item Added To Cart';
export const ITEM_REMOVED_FROM_CART = 'Item Removed From Cart';
export const ITEM_UPDATED_IN_CART = 'Item Updated In Cart';
